import React, { FunctionComponent } from "react"
import { Button, OverlayTrigger, Spinner } from "react-bootstrap"
import ClientPortalEmployeeAccessLevelAreaTypes from "../Types/ClientPortalEmployeeAccessLevelAreaTypes"
import UpdateUserType from "../UpdateUserType/UpdateUserType"
import EALAService from "../Utils/EALAService"
import "./EALAHeader.css"

interface EALAHeaderProps {
    manageParentState: Function
    callParentFunction: Function
    AccessLevelID: number
    ealas: ClientPortalEmployeeAccessLevelAreaTypes[]
    editBusy: boolean
    editIsDirty: boolean
    fade: boolean
    isNaughty: boolean
}

const EALAHeader: FunctionComponent<EALAHeaderProps> = (props) => {

    const { manageParentState, callParentFunction, AccessLevelID, ealas, editBusy, editIsDirty, fade, isNaughty } = props
    const { EALAServiceTooltip } = EALAService

    return (
        <div className={`EALAHeader ${fade ? "EALAHeaderFaded" : "EALAHeaderNotFaded"}`}>
            <div className="EALAHeaderLeft">
                <div className="EALAPickLevelWrapper">
                    <UpdateUserType
                        callParentFunction={callParentFunction}
                        AccessLevelID={AccessLevelID}
                        isNaughty={isNaughty}
                    />
                </div>
            </div>
            {!editBusy && <div className="EALAHeaderRight">
                {!isNaughty && <OverlayTrigger placement="left" overlay={EALAServiceTooltip(`${editIsDirty ? "Save or revert your changes before adding new areas" : "Add new areas"}`)}>
                    <div className={`AddEALABtn ${editIsDirty ? "AddEALABtnDisabled" : "AddEALABtnEnabled"}`}>
                        <span className="material-icons" onClick={() => {
                            if (!editIsDirty) {
                                manageParentState([{ key: "addEala" }])
                            }
                        }}>add</span>
                    </div>
                </OverlayTrigger>}
                <div className="SaveEALAsBtn">
                    {!isNaughty && <Button disabled={!editIsDirty} onClick={() => callParentFunction("editEALAS", ealas, null)}>Save</Button>}
                </div>
            </div>}
            {editBusy && <div className="EALAHeaderEditBusy">
                <Spinner id="eala-header-edit-busy-spinner" animation="border"></Spinner>
            </div>}
        </div>
    )
}

export default EALAHeader